import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {AddToCartWidgetComponent} from "./components/add-to-cart-widget/add-to-cart-widget.component";
import {WishlistWidgetComponent} from "./components/wishlist-widget/wishlist-widget.component";
import {ProductFormatComponent} from "./components/add-to-cart-widget/product-format/product-format.component";
import {CofaWidgetComponent} from "./components/cofa-widget/cofa-widget.component";
import {LotNumberRequestPanelComponent} from "./components/cofa-widget/lot-number-request-panel/lot-number-request-panel.component";
import {LotNumberSearchPanelComponent} from "./components/cofa-widget/lot-number-search-panel/lot-number-search-panel.component";

@NgModule({
    declarations: [
        AddToCartWidgetComponent,
        WishlistWidgetComponent,
        CofaWidgetComponent,
        ProductFormatComponent,
        LotNumberSearchPanelComponent,
        LotNumberRequestPanelComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        AddToCartWidgetComponent,
        WishlistWidgetComponent,
        CofaWidgetComponent
    ]
})
export class ProductDetailsModule {
}
